import React from "react";
import { Link, useNavigate } from "react-router-dom";
import SupremeLogo from "../Common/SupremeLogo"; // Step 1

import instagramIcon from "../../assets/icons/instagram2.svg";

const mainLinks = [
  { name: "Home", path: "/home" },
  { name: "Releases", path: "/releases" },
  { name: "Charts", path: "/charts" },
  { name: "Playlists", path: "/playlist" },
  { name: "Exclusives", path: "/exclusives" },
  { name: "Producers", path: "/producer-packs" },
  { name: "Remixers", path: "/remixers" },
];

const secondaryLinks = [
  { name: "FAQ", path: "/faq" },
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "Terms of Use", path: "/terms" },
  { name: "Contact Us", path: "/contact" },
];

const socialIcons = [
  {
    icon: instagramIcon,
    alt: "Instagram",
    link: "https://www.instagram.com/supremeedits.music/",
  },
  // { icon: discordIcon, alt: "Discord" },
  // { icon: twitterIcon, alt: "Twitter" },
  // { icon: facebookIcon, alt: "Facebook" },
  // { icon: youtubeIcon, alt: "YouTube" },
];

const Footer = () => {
  return (
    <footer className="relative z-10 w-full bg-transparent py-12 px-6 text-white flex flex-col items-center gap-10 border-t border-[#262626] mb-[36px] lg:mb-0">
      <div className="w-full max-w-[1600px] mx-auto ">
        <div className="block sm:hidden">
          <div className="flex flex-col items-start gap-8">
            {/* Logo */}
            <Link to="/home" translate="no" className="w-full notranslate">
              <div className="h-12 w-[186px]">
                <SupremeLogo />
              </div>
            </Link>

            {/* Info and Follow side-by-side */}
            <div className="flex w-full justify-between items-start">
              {/* INFO section */}
              <div>
                <h3 className="text-xs font-semibold text-white mb-2 tracking-widest">
                  INFO
                </h3>
                <ul className="space-y-1 text-[13px] text-gray-300">
                  {secondaryLinks.map((link, i) =>
                    link.name === "Contact Us" ? (
                      <li key={i}>
                        <a
                          href="https://mail.google.com/mail/?view=cm&fs=1&to=support@supremeedits.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:underline"
                        >
                          {link.name}
                        </a>
                      </li>
                    ) : (
                      <li key={i}>
                        <Link to={link.path} className="hover:underline">
                          {link.name}
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* FOLLOW section */}
              <div className="mr-20">
                <h3 className="text-xs font-semibold text-white mb-2 tracking-widest">
                  FOLLOW
                </h3>
                <div className="flex gap-3">
                  {socialIcons.map(({ icon, alt, link }, i) => (
                    <a
                      key={i}
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[20px] h-[20px] opacity-70 hover:opacity-100"
                    >
                      <img src={icon} alt={alt} className="w-full h-full" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden sm:flex flex-col gap-6 items-center">
          {/* Main Links with navigation */}
          <div className="flex flex-wrap justify-center gap-[26px] text-[16px] md:text-[20px] font-light">
            {mainLinks.map((link, i) => (
              <Link
                key={i}
                to={link.path}
                className="relative text-white transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-gradient-to-r after:from-[#52FAF0] after:to-[#197AD0] hover:after:w-full after:transition-all after:duration-300 font-light"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Secondary Links (you can add routes if needed) */}
          <div className="flex flex-wrap justify-center gap-[26px] text-[16px] md:text-[20px] font-light">
            {secondaryLinks.map((link, i) =>
              link.name === "Contact Us" ? (
                <a
                  key={i}
                  href="mailto:support@supremeedits.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-gradient-to-r after:from-[#52FAF0] after:to-[#197AD0] hover:after:w-full after:transition-all after:duration-300"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={i}
                  to={link.path}
                  className="relative transition-colors duration-300 after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-gradient-to-r after:from-[#52FAF0] after:to-[#197AD0] hover:after:w-full after:transition-all after:duration-300"
                >
                  {link.name}
                </Link>
              )
            )}
          </div>
        </div>

        <div className="hidden sm:block w-full h-[1px] bg-[#262626] my-8" />

        {/* Logo and Social Icons */}
        <div className="hidden sm:flex justify-center md:justify-between items-center flex-wrap gap-6 sm:gap-6 px-2 custom-logo-footer-spacing">
          <Link
            to="/home"
            className="cursor-pointer hover:opacity-80 transition-opacity z-50"
          >
            <div translate="no" className="flex items-center w-[186.58px] h-[48.29px] notranslate">
              <SupremeLogo />
            </div>
          </Link>

          <div className="flex items-center gap-[35px] custom-social-gap">
            {socialIcons.map(({ icon, alt, link }, i) => (
              <a
                key={i}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="w-[20px] h-[20px] opacity-70 hover:opacity-100 cursor-pointer"
              >
                <img src={icon} alt={alt} className="w-full h-full" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
